module.exports = __webpack_public_path__ + "12e85489a6e97b3b954e9c2d3280a061.png";